export default {
  setBoard(state, payload) {
    state.board = payload;
  }
}
